class FilterButton extends HTMLElement {
  constructor () {
    super()
    this.facetLink = this.querySelector('button')
    this.facetLink.setAttribute('role', 'button')
    this.facetLink.addEventListener('click', this.closeFilter.bind(this))
    this.facetLink.addEventListener('keyup', event => {
      event.preventDefault()
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter()
    })
    this.form = document.querySelector('.js-Collection_Filters')
  }

  closeFilter () {
    const selector = `[name="${this.facetLink.dataset.name}"][value="${
      this.facetLink.dataset.value
    }"]`
    const filterQueryParam = encodeURI(
      `${this.facetLink.dataset.name}=${this.facetLink.dataset.value}`
    )
      .replaceAll('%20', '+')
      .replace('&', '%26')
    const params = window.location.search.replace(`&${filterQueryParam}`, '')
    document.querySelector(selector).click()
    document.querySelector('.js-Collection_ApplyFilters').click()
    history.pushState({ params }, '', `${window.location.pathname}${params}`)
  }
}

customElements.define('filter-button', FilterButton)
